// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".persisted-accounts-container .card .remove-icon{display:none;padding-right:0.25em;position:absolute;right:0;top:0}.persisted-accounts-container .card:hover .remove-icon{display:block}\n", ""]);
// Exports
module.exports = exports;
